import type { ProfileColumnDef } from './types'

/**
 * How far a pinned fixed column sits from its edge: the widths of the pinned fixed columns
 * before it on the same side (left ones counted from the left, right ones from the right).
 * The first pinned column on each side, and any column that is not a pinned fixed one, get 0.
 */
export const computeStickyOffset = <TKey extends string>(
    visibleColumns: ProfileColumnDef<TKey>[],
    fixedColumnKeys: Set<string>,
    getColumnWidth: (key: TKey) => number,
    key: TKey
): number => {
    const column = visibleColumns.find((col) => col.key === key)
    if (!column?.sticky || !fixedColumnKeys.has(key)) return 0
    const sameSide = visibleColumns.filter((col) => col.sticky === column.sticky && fixedColumnKeys.has(col.key))
    const fromEdge = column.sticky === 'left' ? sameSide : [...sameSide].reverse()
    let offset = 0
    for (const col of fromEdge) {
        if (col.key === key) break
        offset += getColumnWidth(col.key)
    }
    return offset
}
